import React from 'react';

export interface ExperienceProps {}

const Experience: React.FC<ExperienceProps> = (props) => {
    return (
        <div className="site-page-content">
            <h1>Expertise</h1>
            <h3>Areas of Operation</h3>
            <br />
            <div className="text-block">
                <p>
                    A comprehensive toolkit for information dominance, grounded
                    in academic rigor and operational experience.
                </p>
            </div>
            <div style={styles.headerContainer}>
                <div style={styles.header}>
                    <div style={styles.headerRow}>
                        <h1>Information Warfare</h1>
                    </div>
                    <div style={styles.headerRow}>
                        <h3>Core Competency</h3>
                    </div>
                </div>
            </div>
            <div className="text-block">
                <p>
                    Designing and deploying defensive and offensive narrative
                    operations. Neutralizing disinformation campaigns,
                    identifying adversarial networks, and establishing
                    information dominance in contested environments.
                </p>
            </div>
            <div style={styles.headerContainer}>
                <div style={styles.header}>
                    <div style={styles.headerRow}>
                        <h1>Social Engineering</h1>
                    </div>
                    <div style={styles.headerRow}>
                        <h3>Core Competency</h3>
                    </div>
                </div>
            </div>
            <div className="text-block">
                <p>
                    Leveraging behavioral psychology and semantic analysis to
                    craft stories that resonate at cognitive and emotional
                    levels. Architecting master narratives that align
                    stakeholder perceptions.
                </p>
            </div>
            <div style={styles.headerContainer}>
                <div style={styles.header}>
                    <div style={styles.headerRow}>
                        <h1>Strategic Narrative</h1>
                    </div>
                    <div style={styles.headerRow}>
                        <h3>Core Competency</h3>
                    </div>
                </div>
            </div>
            <div className="text-block">
                <p>
                    Transforming fragmented information into coherent
                    storylines. From sovereign-state situation rooms to HNWI
                    living rooms, converting raw intelligence into
                    executive-grade narratives.
                </p>
            </div>
            <div style={styles.headerContainer}>
                <div style={styles.header}>
                    <div style={styles.headerRow}>
                        <h1>Sovereign Shield</h1>
                        <h4>For HNWIs</h4>
                    </div>
                    <div style={styles.headerRow}>
                        <h3>The Dome Protocol</h3>
                    </div>
                </div>
            </div>
            <div className="text-block">
                <p>
                    You have wealth. Now you need immunity against cancel
                    culture, scandals, and oblivion. And a legacy that
                    transcends mere fortune. We protect your narrative and
                    architect your legend.
                </p>
                <br />
                <ul>
                    <li>
                        <p>
                            <b>Reputation Fortification —</b> Creation of
                            dormant positive content networks saturating search
                            engines (SEO Warfare). Attacks are drowned in your
                            controlled narrative.
                        </p>
                    </li>
                    <li>
                        <p>
                            <b>The Legacy Script —</b> Ghostwriting manifestos,
                            elite conference placements (Davos, TED), strategic
                            philanthropic alignment. We write your biography in
                            real-time.
                        </p>
                    </li>
                </ul>
            </div>
            <div style={styles.headerContainer}>
                <div style={styles.header}>
                    <div style={styles.headerRow}>
                        <h1>Market Dominance</h1>
                        <h4>For Businesses</h4>
                    </div>
                    <div style={styles.headerRow}>
                        <h3>Market Hegemony Operations</h3>
                    </div>
                </div>
            </div>
            <div className="text-block">
                <p>
                    Survival and domination. You are at war for market share,
                    talent, and valuation. We make your competition irrelevant
                    and protect you from market manipulation.
                </p>
                <br />
                <ul>
                    <li>
                        <p>
                            <b>Category Design & Warfare —</b> Doctrine
                            creation, market renaming, sales deck engineering.
                            We impose a new market vision where your company is
                            the only logical choice.
                        </p>
                    </li>
                    <li>
                        <p>
                            <b>Counter-Espionage & Short-Seller Defense —</b>{' '}
                            Active intelligence monitoring and counter-narrative
                            deployment. Reverse FUD (Fear, Uncertainty, Doubt)
                            operations against adversaries.
                        </p>
                    </li>
                </ul>
            </div>
            <div style={styles.headerContainer}>
                <div style={styles.header}>
                    <div style={styles.headerRow}>
                        <h1>National Resilience</h1>
                        <h4>For Governments</h4>
                    </div>
                    <div style={styles.headerRow}>
                        <h3>Statecraft & Cognitive Security</h3>
                    </div>
                </div>
            </div>
            <div className="text-block">
                <p>
                    Stability and soft power. Here the stakes are not money.
                    They are history and order maintenance. The most complex
                    level of narrative warfare.
                </p>
                <br />
                <ul>
                    <li>
                        <p>
                            <b>Nation Narrative Building —</b> Creation of the
                            "National Legend". International influence
                            campaigns. We don't sell a country—we sell a future
                            destination.
                        </p>
                    </li>
                    <li>
                        <p>
                            <b>Anti-Disinformation Unit —</b> Detection:
                            conversation flow analysis to spot coordinated
                            attacks. Inoculation: pre-bunking population against
                            false narratives. Counter-Ops: massive truth
                            narrative deployment.
                        </p>
                    </li>
                </ul>
                <br />
                <p>
                    "In a world of generative AI, truth is malleable. We build
                    your reality and destroy your enemies' fictions."
                </p>
            </div>
        </div>
    );
};

const styles: StyleSheetCSS = {
    header: {
        flexDirection: 'column',
        justifyContent: 'space-between',
        width: '100%',
    },
    headerContainer: {
        alignItems: 'flex-end',
        width: '100%',
        justifyContent: 'center',
    },
    headerRow: {
        justifyContent: 'space-between',
        alignItems: 'flex-end',
    },
};

export default Experience;
